module.exports = __webpack_public_path__ + "img/id_card.431ca89d.png";